export default __webpack_public_path__ + "47a15586ffa21e7a0620dd2594e91c8e.png";